import React from 'react';
import { CreateSurveyProps } from '../common/CreateSurveyProps';
import { DownloadCsv, GetDateString, GetFileName, sanatizeStringForCsv } from "../common/helperFunctions";
import produce from 'immer';
import { SurveyModel } from '../models/survey.model';
import Header from "../components/header";
import { SubmissionModel } from '../models/Submission.model';
import { Link } from 'react-router-dom';
import { AnswerIdValueModel } from '../models/SurveySubmission.model';
import { PDF_MatrixRowAndColumn_Seperator, QuestionType_MATRIX, QuestionType_MCQ } from '../common/constants';
import { QuestionModel } from '../models/question.model';
import authHeader from '../services/auth-header';

export interface SubmissionsState {
    isLoading: number;
    survey: SurveyModel
}
 
class Submissions extends React.Component<CreateSurveyProps, SubmissionsState> {
    state = {
        isLoading: -1,
        survey: new SurveyModel()
    }

    // This method is called when the component is first added to the document
    public componentDidMount() {
        const surveyId = this.props.match.params.surveyId || 0;

        fetch(`/Admin/Answers/${surveyId}`, authHeader("GET", '', ''))
        .then(response => response.json() as Promise<SurveyModel>
        )
        .then(data => {
            this.setState(produce(this.state, draftState => {
                draftState.survey = data;
                draftState.isLoading = 0;
            }));
        })
        .catch(error => {
            this.setState(produce(this.state, draftState => {
                draftState.isLoading = 0;
            }));
        });
    }

    render() { 
        // const heading = this.props.survey.name || this.props.survey.title || this.props.survey.titleEn || '';

        return (
            <>
                <Header props={this.props}></Header>
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <h3 className="mb-4">Campaign Information</h3>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="d-flex flex-row-reverse">
                            <Link className="btn btn-warning" to={`/search`}>Campaign List</Link>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <button className="btn btn-primary mr-1" onClick={() => this.downloadCsvAll()}>All Submission CSV</button>
                        <button className="btn btn-primary mr-1" onClick={() => this.downloadPdf(null, this.state.survey.titleEn)}>All Submission PDF</button>
                    </div>
                </div>
                { this.renderSurveyInfo() }
                { this.renderSubmissions() }
            </>
        );
    }

    renderSurveyInfo() {
        if (this.state.survey !== null && 
            this.state.survey !== undefined && 
            this.state.survey && 
            this.state.survey.surveyId !== undefined) {
            return (
                <>
                <table className="table table-striped">
                    <tbody>
                    <tr><th>Id:</th><td>{this.state.survey.surveyId}</td></tr>
                    <tr><th>Name:</th><td>{this.state.survey.titleEn}</td></tr>
                    </tbody>
                </table>
                </>
            );
        }

        return('<></>');
    }

    private renderSubmissions() {
        return (
            <>
            <h3>Submissions:</h3>
                { this.state.survey.submissions.map(l => 
                    <React.Fragment key={l.submissionId}>
                    <div className="main-row border-top border-success">
                        <div className="col pl-0">
                            <table className="table table-striped">
                                <tbody>
                                        <tr>
                                            {/*<th>Browser</th>*/}
                                            {/*<th>IP&nbsp;Address</th>*/}
                                            {/*<th>Link</th>*/}
                                            <th>Submitted&nbsp;On</th>
                                            <th>Download</th>
                                        </tr>
                                        <tr>
                                            {/*<td>{ l.browser }</td>*/}
                                            {/*<td>{ l.ipAddress }</td>*/}
                                            {/*<td>{ l.link }</td>*/}
                                            <td>{ GetDateString(l.submittedOn, true) }</td>
                                            <td><button className="btn btn-primary ms-1" onClick={() => this.downloadPdf(l.submissionId, this.state.survey.titleEn)}>PDF</button><button className="btn btn-primary mr-1" onClick={() => this.downloadCsv(l.submissionId)}>CSV</button></td>
                                        </tr>
                                        <tr>
                                            <td colSpan={5}>
                                            &nbsp;
                                            </td>
                                        </tr>
                                </tbody>
                            </table>
                            { this.renderQuestionAnswers(l) }
                        </div>
                    </div>
                    <br/>
                    </React.Fragment>
                )}
            </>
        );
    }

    private renderQuestionAnswers(l: SubmissionModel){
        return (
            <div className="row" key={`sub-${l.submissionId}`}>
            
            { l.answers.map((a) => {
                const question = this.getQuestion(a.questionId);
                const questionText = this.getQuestionText(question);

                return (
                    <div className="col-sm-12 mb-3" key={a.answerId}>
                        <label className="form-label fw-bold">{questionText}</label>
                        {
                            this.getAnswerHtml(a, question)
                        }
                    </div>
                );
                }
            )}
            </div>
        );
    }

    private getAnswerHtml(a:AnswerIdValueModel, question: QuestionModel | undefined) {
        if (a.mcqAnswers && a.mcqAnswers.length > 0) {
            return <ul>
                {
                    this.getMcqUlListAnswer(a, question)
                }
            </ul>
        } else if (a.matrixAnswers && a.matrixAnswers.length > 0) {
            return <ul>
                {
                    this.getMatrixAnswer(a, question)
                }
            </ul>
        }

        return <p>{a.answer}</p>
    }

    private getQuestion(questionId: number): QuestionModel | undefined {
        
        return this.state.survey.questions.find( q => q.questionId === questionId);

    }

    private getQuestionText(question: QuestionModel | undefined): string {

        return question !== undefined ? question.questionEn : '';
    }

    private getQuestionTextForAllCsv(question: QuestionModel | undefined): string[] {

        if (question?.code === QuestionType_MATRIX) {
            const matrixQuestions = question.matrixRows.map((e) => sanatizeStringForCsv(e.textEn));

            return matrixQuestions;
        }

        return [question !== undefined ? sanatizeStringForCsv(question.questionEn) : ''];
    }

    private downloadPdf(submissionId: number | null, link: string | null) {
        const surveyId = this.state.survey.surveyId;
        const submissionIdVal = submissionId ? submissionId : '';
        fetch(`/Admin/GetSubmissionPdf/${surveyId}/${submissionIdVal}`, authHeader("GET", '', ''))
        .then(response => response.blob())
        .then(blob => {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = GetFileName(link, 'pdf');
            document.body.appendChild(a);
            a.click();    
            a.remove();
        });

    }

    private downloadCsvAll() {

        let csv = sanatizeStringForCsv(this.state.survey.titleEn);
        csv += '\n \n';
        let questionList: {questionId:number, question: QuestionModel | undefined}[] = [];

        for (let i = 0; i < this.state.survey.submissions.length; i++) {
            const s = this.state.survey.submissions[i];

            if (s !== undefined) {
                csv += sanatizeStringForCsv('Recipient Number');
                csv += ',';
                csv += sanatizeStringForCsv('Submitted On');
                csv += ',';
                csv += sanatizeStringForCsv('Time Submitted');
                csv += ',';

                for (let ansCount = 0; ansCount < s.answers.length; ansCount++) {
                    const question = this.getQuestion(s.answers[ansCount].questionId); 
                    csv += this.getQuestionTextForAllCsv(question).join(',');
                    csv += ',';

                    questionList.push ( {questionId: s.answers[ansCount].questionId, question:question} );

                };
                csv += '\n';

                break;
            }
        }

        this.state.survey.submissions.forEach( (s, i) => {

            if (s !== undefined) {
                csv += (i+1);
                csv += ',';
                const date = new Date(s.submittedOn);
                let submissionDate = `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`; 
                csv += sanatizeStringForCsv(submissionDate);
                csv += ',';

                let submissionTime = `${date.getHours()}:${date.getMinutes()}`; 
                csv += sanatizeStringForCsv(submissionTime);
                csv += ',';

                questionList.forEach((q) => {
                    const ans = s.answers.find( a => a.questionId === q.questionId);
                    
                    if (ans !== undefined) {

                        csv += this.getCsvAnswerForAllCsv(ans, q.question);

                    }

                    csv += ',';
                });

                csv += '\n';
            }
        });
        
        DownloadCsv(csv, this.state.survey.titleEn);
    }

    private downloadCsv(submissionId: number) {

        const submission = this.state.survey.submissions.find( f => f.submissionId === submissionId);

        if (submission !== undefined) {
            let csv = sanatizeStringForCsv(this.state.survey.titleEn);
            csv += '\n \n';
            csv += sanatizeStringForCsv('Submitted On: ' + submission.submittedOn);
            //csv += '\n';
            //csv += sanatizeStringForCsv('Link: ' + submission.link);
            //csv += '\n';
            //csv += sanatizeStringForCsv('Browser: ' + submission.browser);
            //csv += '\n';
            //csv += sanatizeStringForCsv('IP Address: ' + submission.ipAddress);
            csv += '\n \n';

            submission.answers.forEach( (a) => {
                const question = this.getQuestion(a.questionId);
                const questionText = this.getQuestionText(question); 
                csv += sanatizeStringForCsv(questionText);
                csv += '\n';
                csv += sanatizeStringForCsv( this.getCsvAnswer(a, question) );
                csv += '\n \n';
            });

            DownloadCsv(csv, this.state.survey.titleEn);

        }
    }

    getCsvAnswer(ans: AnswerIdValueModel, question: QuestionModel | undefined): string {

        switch (question?.code) {
            case QuestionType_MATRIX:
                return this.getMatrixAnswerArray(ans, question).join('\n');
            case QuestionType_MCQ:
                return this.getMcqAnswerArray(ans, question).join('\n');
            default:
                return ans.answer;
        }
    }

    getCsvAnswerForAllCsv(ans: AnswerIdValueModel, question: QuestionModel | undefined): string {

        switch (question?.code) {
            case QuestionType_MATRIX:
                return this.getMatrixAnswerArrayForAllCsv(ans, question).map((e) => sanatizeStringForCsv(e)).join(',');
            case QuestionType_MCQ:
                return sanatizeStringForCsv(this.getMcqAnswerArray(ans, question).join('\n'));
            default:
                return sanatizeStringForCsv(ans.answer);
        }
    }

    getMatrixAnswer(ans: AnswerIdValueModel, question: QuestionModel | undefined) {
        return (
            <table className='table table-secondary table-striped'>
                <thead>
                    <tr>
                        <th>Question</th>
                        <th>Answer</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        this.getMatrixAnswerArray(ans, question).map( (i, index) => {
                            const QandA = i.split(PDF_MatrixRowAndColumn_Seperator);
                            return <tr key={index}>
                                <td>{ QandA[0] }</td>
                                <td>{ QandA[1] }</td>
                            </tr>
                        })
                    }
                </tbody>
            </table>
        )
    }

    getMatrixAnswerArray(ans: AnswerIdValueModel, question: QuestionModel | undefined): string[] {
        
        const matrixAns = ans.matrixAnswers.map((i) => { 
            if (question) {
                const row = question.matrixRows.find( o => o.matrixId === i.matrixRowId);
                const col = question.matrixColumns.find( o => o.matrixId === i.matrixColumnId);
            
                if (row && col)
                return `${row.textEn}${PDF_MatrixRowAndColumn_Seperator}${col.textEn}`;
            }

            return '';
        });
        
        return matrixAns;
    }

    getMatrixAnswerArrayForAllCsv(ans: AnswerIdValueModel, question: QuestionModel | undefined): string[] {
        
        const matrixAns = question?.matrixRows.map((row) => {
        
            let tempAns = ans.matrixAnswers.find(x => x.matrixRowId === row.matrixId);

            if (tempAns != undefined) {
                const col = question.matrixColumns.find( o => o.matrixId === tempAns?.matrixColumnId);
            
                if (row && col)
                return `${col.textEn}`;
            }

            return '';

        });

        if (matrixAns !== undefined)
            return matrixAns;
        
        return [];
    }

    getMcqUlListAnswer(ans: AnswerIdValueModel, question: QuestionModel | undefined) {
        return this.getMcqAnswerArray(ans, question).map( (i, index) => {
            return <li key={`${ans.answerId}-${index}`}>{i}</li>
        });
    }

    getMcqAnswerArray(ans: AnswerIdValueModel, question: QuestionModel | undefined): string[] {
 
        const mcqAns = ans.mcqAnswers.map((i) => { 
            let other = '';
            
            if (question) {
                const x = question.mcqOptions.find( o => o.mcqOptionId === i.mcqOptionId && o.isOther);
                if( x !== undefined)
                    other = '*Other:';
            }
            return `${other}${i.answerEn}`;
        });
        
        return mcqAns;
    }
}
 
export default Submissions;
